<template>
  <form :data-vv-scope="scope" @submit.prevent="submitContact(scope)">
    <p class="mt-4">Fill out the form or email <a href="mailto:support@elementari.com">support@elementari.com</a>  </p>
    <v-text-field
      v-model="subject"
      v-validate="'required: true'"
      :error-messages="errors.collect(scope + '.subject')"
      :label="$t('forms.contact.subject')"
      :name="$t('forms.contact.subject')"
      data-vv-name="subject"
      required
    />
    <v-text-field
      v-model="email"
      v-validate="'required|email'"
      :error-messages="errors.collect(scope + '.email')"
      :label="$t('navbar.signup.form.email')"
      data-vv-name="email"
      required
    />
    <v-textarea
      v-model="message"
      v-validate="'required'"
      :error-messages="errors.collect(scope + '.message')"
      :label="$t('forms.contact.message')"
      :placeholder="$t('forms.contact.message_placeholder')"
      name="message"
      data-vv-name="message"
      required
    />
    <v-btn
      :disabled="errors.any(scope)"
      block
      color="primary"
      depressed
      type="submit"
    >
      {{ $t('actions.submit') }}
    </v-btn>
  </form>
</template>

<script>
export default {
  props: {
    scope: {
      type: [String],
      required: false,
      default: 'contact-form'
    }
  },
  inject: ['$validator'],
  data: () => ({
    email: '',
    subject: '',
    message: '',
    error: null
  }),
  methods: {
    async submitContact(scope) {
      if (!(await this.$validator.validateAll(scope))) return
      const formdata = {
        email: this.email,
        subject: this.subject,
        message: this.message
      }
      try {
        const res = await this.$api.contactForm(formdata)
        this.$toast.success(this.$i18n.t('forms.contact.success'), {
          theme: 'bubble',
          duration: 5000,
        })
        if (scope == 'contact-form-page') return
        this.toggleContactDialog()
      } catch (e) {
        this.$toast.error(this.$i18n.t('forms.contact.error'), {
          theme: 'bubble',
          duration: 5000,
        })
      }
    },
    toggleContactDialog() {
      this.$store.dispatch('setContactDialog', !this.$store.state.contactDialog)
    }
  }
}
</script>
